<div class="d-flex flex-grow-1 flex-column align-items-center flex-sm-row gap py-2 py-sm-0 px-2">
  <div>&#169; finanzen.net zero GmbH {{ currentYear }}</div>
  <a class="d-block" href="https://www.finanzen.net/zero/impressum/" target="_blank" rel="noopener noreferrer">
    {{ 'footer.legal.imprint' | transloco }}
  </a>
  <a class="d-block" href="https://www.finanzen.net/zero/datenschutz/" target="_blank" rel="noopener noreferrer">
    {{ 'footer.legal.privacy' | transloco }}
  </a>
  <a class="d-block" href="https://www.finanzen.net/zero/disclaimer/" target="_blank" rel="noopener noreferrer">
    {{ 'footer.legal.disclaimer' | transloco }}
  </a>
  <a class="d-block cursor-pointer" (click)="sourcePoint.displayPrivacyManagerModal()">
    {{ 'footer.legal.privacy-settings' | transloco }}
  </a>
  @if (!hideLogout) {
    <div class="d-block cursor-pointer" (click)="authService.explicitLogout()">
      <span> {{ 'footer.logout' | transloco }}</span>
      <svg class="icon icon-12 ml-1">
        <use xlink:href="/assets/img/svgs/svgset.svg#logout" />
      </svg>
    </div>
  }
</div>
